module.exports = __webpack_public_path__ + "img/swot_description.9a0cdfc8.png";